import {
	Box,
	ButtonLayout,
	ButtonPrimary,
	ButtonSecondary,
	Grid,
	GridItem,
	Text3,
	skinVars,
	useScreenSize,
} from "@telefonica/mistica";
import { observer } from "mobx-react-lite";
import React from "react";
import { HeroDataInfo, ScreenResponsive } from "../../organisms";
import PinInput from "../../organisms/PinInput";
import { strings } from "../../../localization";

interface IProps {
	screenTitle?: string;
	title: string;
	description: string;
	icon: JSX.Element;
	codeOTP: string;
	buttonPrimaryLabel?: string;
	buttonSecondaryLabel?: string;
	attempts: number;
	isDisabled?: boolean;
	isDisabledInput?: boolean;
	isTokenError?: boolean;
	isLoading?: boolean;
	tokenHelperText?: string;
	setCodeOtp(t: string): void;
	onBack(shouldTriggerEvent?: boolean): void;
	onResend(): void;
	onContinue(): Promise<void>;
}

export const ValidationOTPToken: React.FC<IProps> = observer((props) => {
	const { buttonPrimary, buttonSecondary } = strings.components.buttons;
	const { anticipation } = strings.pages.navigation;
	const {
		screenTitle = anticipation,
		title,
		description,
		icon,
		codeOTP,
		buttonPrimaryLabel = buttonPrimary,
		buttonSecondaryLabel = buttonSecondary,
		attempts,
		isDisabled = false,
		isDisabledInput = false,
		isTokenError,
		isLoading = false,
		tokenHelperText,
		onBack,
		onResend,
		onContinue,
		setCodeOtp,
	} = props;
	const { isDesktopOrBigger } = useScreenSize();

	return (
		<ScreenResponsive navigationTitle={screenTitle} onBack={onBack}>
			<Box paddingBottom={isDesktopOrBigger ? 24 : 0}>
				<Box paddingBottom={isDesktopOrBigger ? 80 : 32} paddingTop={isDesktopOrBigger ? 40 : 32}>
					<Grid columns={isDesktopOrBigger ? 4 : 1} justifyContent={"center"}>
						<GridItem columnStart={2} span={isDesktopOrBigger ? 2 : 1}>
							<Box width={isDesktopOrBigger ? 600 : "100%"}>
								<Box paddingBottom={24}>
									<HeroDataInfo icon={icon} title={title} description={description} />
								</Box>
								<Grid columns={{ maxSize: 392 }} justifyContent={"center"}>
									<PinInput
										value={codeOTP}
										onChange={setCodeOtp}
										attempts={attempts}
										isError={isTokenError}
										helperText={tokenHelperText}
										onResend={onResend}
										isDisabled={isDisabledInput}
									/>
									<ButtonLayout align={isDesktopOrBigger ? "left" : "center"}>
										<ButtonPrimary
											showSpinner={isLoading}
											onPress={onContinue}
											style={{ width: isDesktopOrBigger ? "auto" : "100%" }}
											disabled={codeOTP.length < 6 || isDisabled || isLoading}
										>
											<Text3 medium color={skinVars.colors.textButtonPrimary} textAlign="center">
												{buttonPrimaryLabel}
											</Text3>
										</ButtonPrimary>
										<ButtonSecondary disabled={isDisabled} onPress={() => onBack(true)} style={{ width: isDesktopOrBigger ? "auto" : "100%" }}>
											<Text3 medium color={skinVars.colors.textButtonSecondary} textAlign="center">
												{buttonSecondaryLabel}
											</Text3>
										</ButtonSecondary>
									</ButtonLayout>
								</Grid>
							</Box>
						</GridItem>
					</Grid>
				</Box>
			</Box>
		</ScreenResponsive>
	);
});
